import { Position, State } from 'src/types'
import { catchFace } from 'src/features/atoms/glove/drawer/rightThrow/glove/front/catchFace'
import { edges } from 'src/features/atoms/glove/drawer/rightThrow/glove/front/edge'
import { hamidashi } from 'src/features/atoms/glove/drawer/rightThrow/glove/front/hamidashi'
import { listLining } from 'src/features/atoms/glove/drawer/rightThrow/glove/front/listLining'
import { lace } from 'src/features/atoms/glove/drawer/rightThrow/glove/front/lace'
import { backLaceDrawerOfFront, engravedDrawer } from 'src/features/atoms/glove/drawer/common/useCanvasHelper'
import { rightLaceOfNetWebDrawer, webOfGloveFrontDrawer } from 'src/features/atoms/glove/drawer/rightThrow/glove/front/web/useCanvasWebFront'
import { canvasResetter } from 'src/util/canvas'
import { fingers } from './back'
import { AKG_21_PRODUCT_NUMBER } from 'src/features/atoms/glove/japan/constants/baseModel'

export const atomsCanvasGloveFront = async (ctx: CanvasRenderingContext2D, state: State, position: Position): Promise<void> => {
  // リセット
  canvasResetter(ctx)
  // 裏革
  listLining(ctx, state.listLiningsMaterial?.color)
  // 背面の紐
  backLaceDrawerOfFront(ctx, state.backLace?.value, state.lace?.color, position, state.baseModel?.productNumber)
  // ウェブの描画
  await webOfGloveFrontDrawer(ctx, state)
  // 捕球面
  catchFace(ctx, state.catchFace.color)

  await fingers(ctx, state)

  // ハミダシ
  hamidashi(ctx, state.hamidashi?.color)
  // ヘリ革
  edges(ctx, state.edge?.color, state.lace?.color, state.stitch?.color, position, state?.bankLaceDirection)
  // ネットウェブのみの革紐
  await rightLaceOfNetWebDrawer(ctx, state)
  // 革紐
  const isUnselectedMaterialPack = state?.materialPack?.value === 'unselected'
  const isAkg21Model = state.baseModel.productNumber === AKG_21_PRODUCT_NUMBER
  const defaultAkg21ModelMaterialPack = isAkg21Model && isUnselectedMaterialPack ? { value: 'vertical', label: '未選択' } : state?.materialPack
  lace(ctx, state.lace?.color, defaultAkg21ModelMaterialPack, position)
  // メーカー捕球面の刻印
  engravedDrawer(ctx, 'atoms', state.catchFace?.color, state.baseModel?.productNumber)
}
